module.exports = __webpack_public_path__ + "img/noimg.7c10e1d3.jpg";